import { useEffect, useState } from 'react'
import clsx from 'clsx'
import TextField from '@mui/material/TextField'
import { dataColumn } from '../../../components/DataColumn'
import { Autocomplete, MenuItem, Select } from '@mui/material'
import { useGetUomandRuomQuery } from '../../../store/api/requestApi'
import { useGetConversionQuery } from '../../../store/api/rfqsApi'
import { isEmpty } from 'lodash'

export const rfqListColumns = () => {
  return [
    dataColumn('rfqMainId', 'RFQId', 80, 'string'),
    dataColumn('rfqNo', 'RFQ No', 150, 'string'),
    dataColumn('bidCount', 'Bid Count', 80, 'number'),
    dataColumn('rfqDeadline', 'RFQ Deadline', 100, 'number'),
    dataColumn('emergency', 'Emergency', 100, 'string'),
    dataColumn('buyer', 'Buyer', 150, 'string'),
    dataColumn('businessCategoryName', 'Business Category', 200, 'string'),
  ]
}

export const itemCodeColumns = () => {
  return [dataColumn('item_Code', 'Item Code', 150), dataColumn('description', 'Description', 200)]
}

export const vendorCodeColumns = [
  {
    field: 'vendorCode',
    headerName: 'Vendor Code',
    width: 200,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'vendorName',
    headerName: 'Vendor Name',
    width: 200,
    headerAlign: 'center',
    align: 'center',
  },
]

const SelectPUOM = ({ params, handleCellEdit, disabled, businessUnitId }) => {
  const { data: puomData, isLoading: puomDataIsLoading } = useGetUomandRuomQuery(businessUnitId)
  const { data: puomDataConversion, isLoading: puomDataConversionIsLoading } = useGetConversionQuery({
    itemCode: params?.row?.itemCode,
    businessUnitId: businessUnitId,
  })

  const [puom, setPuom] = useState({ puomList: { data: [] }, puomListLoading: false })

  useEffect(() => {
    const isAlternativeItem = params?.row?.alternativeItem
    if (isAlternativeItem) {
      setPuom({ puomList: puomData, puomListLoading: puomDataIsLoading })
      return
    }

    const data = isEmpty(puomDataConversion?.data)
      ? { data: [{ uom: params?.row?.defaultUOM ?? '', conv_Factor: 1 }] }
      : puomDataConversion

    const dataLoading = isEmpty(puomDataConversion?.data) ? false : puomDataConversionIsLoading

    setPuom({ puomList: data, puomListLoading: dataLoading })
  }, [puomDataConversion, puomData])

  return (
    <Select
      value={params?.value ?? ''}
      size="small"
      disabled={disabled}
      style={{ fontSize: '0.97rem', height: 30 }}
      onChange={(event) => {
        const puomValue = event.target.value
        const conversionRate = puomValue
          ? puom?.puomList?.data?.find((item) => {
              return item.uom ? item.uom : item.uoM_Name ?? '' === puomValue
            })?.conv_Factor
          : 0

        handleCellEdit({
          id: params.id,
          field: 'puom',
          value: {
            puom: puomValue,
            conversionRate,
          },
        })
      }}
      fullWidth
    >
      {!puom?.puomListLoading &&
        puom?.puomList?.data &&
        puom?.puomList?.data?.map((item, index) => (
          <MenuItem key={index} value={item.uom ? item.uom : item.uoM_Name ?? ''}>
            {item.uom ? item.uom : item.uoM_Name ?? ''}
          </MenuItem>
        ))}
    </Select>
  )
}

export const puomColumn = ({ handleCellEdit, disabled, businessUnitId, businessUnitCode }) => {
  return {
    field: 'puom',
    headerName: 'PUOM',
    type: 'singleSelect',
    width: 100,
    editable: !disabled,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return (
        <SelectPUOM
          disabled={disabled}
          params={params}
          handleCellEdit={handleCellEdit}
          businessUnitId={businessUnitId}
          businessUnitCode={businessUnitCode}
        />
      )
    },
  }
}

export const autocompleteSelectColumn = (
  field,
  headerName,
  width,
  editable = false,
  handleCellEdit,
  columnData = [],
  value,
  label, 
  code
) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    headerAlign: 'center',
    align: 'center',
    cellClassName: 'p-0',
    renderCell: (params) => {
      const selectedOption = columnData?.find((option) => option[value] === params.value)
      return (
        <Autocomplete
          disabled={!editable}
          disablePortal
          id="combo-box-demo"
          options={columnData}
          getOptionLabel={(option) => code ? `${option[code]}-${option[label]}` : option[label]}
          sx={{ width: 500 }}
          value={selectedOption || null}
          // style={!editable ? { color: '#333', backgroundColor: 'hsl(0, 0%, 95%)' } : {}}
          onChange={(e, selectedOption) => {
            if (selectedOption) {
              handleCellEdit({ id: params.id, field: field, value: selectedOption[value] })
            }
          }}
          renderInput={(params) => {
            return <TextField {...params} />
          }}
        />
      )
    },
  }
}

export const autocompleteSelectColumnCondition = (
  field,
  headerName,
  width,
  handleCellEdit,
  columnData = [],
  value,
  label
) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      const selectedOption = columnData.find((option) => option[value] === params?.value?.conditionValue)
      return (
        <Autocomplete
          disabled={params?.value?.disabled || field === 'condition'}
          id="combo-box-demo"
          options={columnData}
          getOptionLabel={(option) => option[label]}
          sx={{ width: 500 }}
          value={selectedOption || null}
          onChange={(event, selectedOption) => {
            if (selectedOption) {
              handleCellEdit({ id: params.id, field: field, value: selectedOption[value] })
            }
          }}
          renderInput={(renderParams) => {
            return <TextField {...renderParams} disabled={params?.value?.disabled || field === 'condition'} />
          }}
        />
      )
    },

    cellClassName: (params) => {
      return clsx(params?.value?.disabled || field === 'condition' ? 'disable-cell p-0' : 'p-0')
    },
  }
}

export const dialogColumn = (field, headerName, width, handleDialog) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return (
        <TextField
          {...params}
          onClick={() => handleDialog(params)}
          disabled={!params?.row?.alternativeItem}
          sx={{
            '& fieldset': {
              border: 'none',
            },
          }}
        />
      )
    },

    cellClassName: (params) => !params?.row?.alternativeItem && 'disable-cell',
  }
}

export const columnEditableForRow = (field, headerName, width, type, handleCellEdit) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    type: type,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return (
        <TextField
          {...params}
          onChange={(event) => {
            handleCellEdit({ id: params.id, field: field, value: event.target.value })
          }}
          inputProps={{
            ...params.inputProps,
          }}
          value={params?.value}
          disabled={!params?.row?.alternativeItem}
          sx={{
            '& fieldset': {
              border: 'none',
            },
          }}
        />
      )
    },
    cellClassName: (params) => !params?.row?.alternativeItem && 'disable-cell',
  }
}

export const columnConversion = (field, headerName, width, type, handleCellEdit) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    type: type,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return (
        <TextField
          {...params}
          disabled={params?.row?.uom === params?.row?.puom}
          type="number"
          value={params?.value}
          onChange={(event) => {
            const conversionValue = event.target.value
            handleCellEdit({ id: params.id, field: field, value: conversionValue })
            // if (!conversionValue || conversionValue.match(/^\d{1,}(\.\d{0,4})?$/)) {
            //   handleCellEdit({ id: params.id, field: field, value: conversionValue })
            // }
          }}
          inputProps={{
            ...params.inputProps,
          }}
        />
      )
    },
    cellClassName: (params) => {
      return clsx(params?.row?.uom === params?.row?.puom ? 'disable-cell p-0' : 'p-0')
    },
  }
}
